import { Subject } from 'rxjs';

interface CookingLoading {
    isShow: boolean;
}

const cookingLoadingSubject = new Subject<CookingLoading>();

export const cookingLoadingService = {
    onLoading,
    loading
};

function onLoading() {
    return cookingLoadingSubject.asObservable();
}

function loading(isShow: boolean) {
    cookingLoadingSubject.next({ isShow });
}
